import { useNavigate } from 'react-router-dom';
import { useEffect, useCallback } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Gift } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  const { user, refreshUser } = useAuth();

  // Validate session on mount - security check
  useEffect(() => {
    // Refresh user to ensure we have correct session
    refreshUser();
    
    // Show cancel notification with friendly message
    toast.info('Gaila, kad apsigalvojai! Bet viskas gerai – tu visada gali sugrįžti, kai jausi, kad atėjo tavo laikas.', {
      duration: 8000,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBackToResults = useCallback(() => {
    // Use replace to prevent back button going to Stripe
    navigate('/rezultatai', { replace: true });
  }, [navigate]);

  const handleBackToHome = useCallback(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-950 via-indigo-950 to-slate-950 flex items-center justify-center p-4">
      <Card className="max-w-md w-full bg-gradient-to-br from-violet-950/90 via-indigo-950/90 to-slate-950/90 border-amber-500/30 p-8 text-center">
        <div className="w-16 h-16 bg-amber-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-4xl">🤔</span>
        </div>
        
        <h2 className="text-2xl font-semibold text-amber-400 mb-3">Mokėjimas atšauktas</h2>
        
        {user && (
          <p className="text-sm text-muted-foreground mb-2">
            Prisijungęs kaip: {user.email}
          </p>
        )}
        
        <p className="text-foreground/80 mb-6">
          Mokėjimas nebuvo baigtas. Nieko tokio – grįžkite prie savo analizės ir tęskite, kai būsite pasiruošę!
        </p>

        <div className="bg-purple-500/10 rounded-lg p-4 mb-6 border border-purple-500/30">
          <p className="text-sm text-foreground/70 italic">
            "Kiekvienas sprendimas yra teisingas savo laiku. Klausykis savęs."
          </p>
        </div>

        <div className="space-y-3">
          <Button
            onClick={handleBackToResults}
            className="w-full bg-gradient-to-r from-amber-400 to-yellow-500 hover:from-amber-500 hover:to-yellow-600 text-black font-bold"
            data-testid="back-to-results-btn"
          >
            <Gift className="w-5 h-5 mr-2" />
            Grįžti prie rezultatų
          </Button>
          
          <Button
            onClick={handleBackToHome}
            variant="ghost"
            className="w-full text-muted-foreground hover:text-foreground"
            data-testid="back-to-home-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Į pradžią
          </Button>
        </div>
      </Card>
    </div>
  );
}
